import styled, { keyframes } from "styled-components"
import img from "../../images/background-small.jpg"
export const BackgroundPage = styled.div`
  background: #1a1a1a;
  background-color: #1a1a1a;
  background-image: url(${img});
  height: 100vh;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-size: cover;
  background-position: center center;
  overflow: hidden;
  width: calc(100% + 2px);
  margin-left: -1px;
  margin-right: -1px;
  margin-top: -1px;
  @media (max-width: 999px) {
      height: 700px;
  }
  
`
const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`
const Pulse = keyframes`
0% {
		transform: scale(0.95);
		text-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
	}

	70% {
		transform: scale(1);
		text-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
	}

	100% {
		transform: scale(0.95);
		text-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
	}
`
const MoveMouse = keyframes`
0% {
    opacity: 1;
    -webkit-transform: translate(-50%, 0);
    -moz-transform: translate(-50%, 0);
    transform: translate(-50%, 0);
  }
  100% {
    opacity: 0;
    -webkit-transform: translate(-50%, 20px);
    -moz-transform: translate(-50%, 20px);
    transform: translate(-50%, 20px);
  }
`

export const Title = styled.h1`
  font-family: "Josefin Sans", sans-serif;
  color: #FFFFFF;
  font-size: 74px;
  letter-spacing: 4px;
  animation: ${Pulse} 2s linear infinite;
  text-shadow: 10px 4px 12px rgba(0, 0, 0, 0.8);
  /* animation-iteration-count: 1; */
`
export const Mouse = styled.div`
 position: absolute;
  bottom: 20px;
  display: inline-block;
  width: 1.875rem;
  height: 3.125rem;
  border-radius: 10rem;
  border: 2px solid #fff;
 &::after {
  -webkit-transform: translate(-50%, 0);
  -moz-transform: translate(-50%, 0);
  transform: translate(-50%, 0);
  content: "";
  position: absolute;
  display: block;
  top: 25%;
  left: 50%;
  width: 6px;
  height: 6px;
  background: #FFFFFF;
  border-radius: 50%;
  -webkit-animation: mouse 2s linear infinite;
  -moz-animation: mouse 2s linear infinite;
  animation: ${MoveMouse} 2s linear infinite;
  }
  @media (max-width: 999px) {
   display: none;
  }
`



// /* mouse */
// .swiper-footer {
//   -webkit-transform: translate(0, 50%);
//   -moz-transform: translate(0, 50%);
//   transform: translate(0, 50%);
//   width: 100%;
//   position: absolute;
//   bottom: 3.125rem;
//   z-index: 40;
// }

